import { Injectable, signal, WritableSignal } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalErrorService } from '@services/global-error.service';
import { Candidates, CandidateSummary } from '@interfaces/candidates.model';
import { environment } from '@environments/environment';
import { ValidateProfilePayload, ValidateProfileResponse } from '../../vendor/add-candidate/add-candidate.model';
import { ProfileValidationService } from '@services/profile-validation.service';

@Injectable({
  providedIn: 'root',
})
export class HiringManagerCandidatesService {
  private baseUrl = environment.apiUrl;
  candidatesSignal: WritableSignal<any> = signal(null);

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorService,
    private profileValidation: ProfileValidationService,
  ) {}

  getCandidates(hiringRequestId: number[] | null, page: number = 1, limit: number = 10, searchKey?: string, searchValue?: string): void {
    let params = new HttpParams()
      .set('page', String(page))
      .set('limit', String(limit));
    
    if (searchKey && searchValue) {
      params = params
        .set('search', 'true')
        .set(searchKey, searchValue);
    }

    this.http
      .post<any>(`${this.baseUrl}/hiring/candidates`, hiringRequestId, { params })
      .subscribe({
        next: (data) => {
          this.candidatesSignal.set(data);
        },
        error: (error) => {
          this.errorHandler.logError(error);
        },
      });
  }

  getAllCandidates(hiringRequestId: number[] | null) {
    this.http
      .post<{ status: string; reason: string; data: CandidateSummary }>(`${this.baseUrl}/hiring/candidates/total`, hiringRequestId)
      .subscribe({
        next: (data) => {
          this.candidatesSignal.set(data);
        },
        error: (error) => {
          this.errorHandler.logError(error);
        },
      });
  }

  validateProfileHistory(payload: ValidateProfilePayload): Observable<ValidateProfileResponse> {
    return this.profileValidation.validateProfile(payload);
  }
}